<template>
  <div class="container  vip container-box">
    <div class="list-header">
      <div class="header-line"></div>
      <div class="header-title">{{$t('my.nav.vip')}}</div>
    </div>
    <div class="common-list  vip-model">
        <div :class="['vip-icon', 'en-vip-icon',{'isEngCss':isChinese}]">{{$t('vip.privileges')}}</div>
        <div :class="['vip-info', 'clearfix' ,'en-vip-info',{'isEngCss':isChinese}]">
          <div>
            <img src="../assets/vip-fanyi.png" alt="" />
            <span>{{$t('vip.des[0]')}}</span>
          </div>
          <div>
            <img src="../assets/vip-read.png" alt="" />
            <span>{{$t('vip.des[1]')}}</span>
          </div>
          <div>
            <img src="../assets/vip-biaozhi.png" alt="" />
            <span>{{$t('vip.des[2]')}}</span>
          </div>
          <div>
            <img src="../assets/vip-guanggao.png" alt="" />
            <span>{{$t('vip.des[3]')}}</span>
          </div>
        </div>
        <div>
          <div class="vip-title">
            <i></i>
            <span>{{$t('vip.full')}}</span>
            <span class="vip-time" v-if="user['isVip']">{{$t('vip.time')+user['vipExpire']}}</span>
          </div>
          <div class="clearfix vip-full-value">
            <div v-for="(o,index) in vipFull"
              v-bind:class="['vip-full-item',{'active':o.active}]"
              :key= "index"
              @click="payChoose(o,index)">
              <p class="vip-full-money">
                <span>&yen;</span>
                <span>{{o.price}}</span>
              </p>
              <p class="vip-full-time">{{o.name}}</p>
            </div>
          </div>
          <div class="vip-full-other">
            <p class="vip-title">{{$t('vip.exchange')}}</p>
            <div v-for="(o,index) in vipPoints"
                 v-bind:class="['vip-caiyunpoints',{'active':o.active}]"
                 :key = 'index'
                 @click="payPoint(o,index)">
              <span>{{o.name}}</span>
              <span class="vip-full-points"><img src="../assets/points.png" alt=""><span>{{o.price}}</span></span>
            </div>
          </div>
        </div>
    </div>
    <div class="vip-agreement" @click="userAgreement=true">{{$t('vip.service')}}></div>
    <div class="vip-pay-full">
      <el-dialog
        :title="$t('vip.paySure')"
        :visible.sync="dialogVisible"
        center
        @close='closeDialog(1)'
        class="clearfix"
        Slot="footer">
        <div class="vip-full-item">
          <p class="vip-full-money">
            <span>&yen;</span>
            <span>{{pay.price}}</span>
          </p>
          <p class="vip-full-time">{{pay.name}}</p>
        </div>
        <div class="need-pay">
          {{$t('vip.pay')}}：<span>{{pay.price}}元</span>
        </div>
        <span slot="footer" class="dialog-footer">
    <!--<el-button @click="dialogVisible = false">取 消</el-button>-->
    <el-button type="primary"
              :class="['en-full-vip-button',{'isEngCss':isChinese}]"
               @click="payVip">{{isPayState}}</el-button>
  </span>
      </el-dialog>
    </div>
    <div class="vip-pay-points">
      <el-dialog
        title=""
        :visible.sync="centerDialogVisible"
        center 
        @close='closeDialog(2)'>
        <span>{{$t('vip.payPoint')}}?</span>
        <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog(2);centerDialogVisible = false;">{{$t('vip.cancel')}}</el-button>
    <el-button type="primary" @click="payVipPoint">{{$t('vip.sure')}}</el-button>
  </span>
      </el-dialog>
    </div>
    <div>
      <el-dialog
        :title="$t('vip.dealTitle')"
        :visible.sync="userAgreement"
        center>
        <div>
          <h4>{{$t("PayAgreement.pange2")}}</h4>
          <p>{{$t("PayAgreement.pange3")}}</p>
          <h4>{{$t("PayAgreement.pange4")}}</h4>
          <p>{{$t("PayAgreement.pange5")}}</p>
          <p>{{$t("PayAgreement.pange6")}}</p>
          <h4>{{$t("PayAgreement.pange7")}}</h4>
          <p>{{$t("PayAgreement.pange8")}}</p>
          <p>{{$t("PayAgreement.pange9")}}</p>
          <h4>{{$t("PayAgreement.pange10")}}</h4>
          <p>{{$t("PayAgreement.pange11")}}</p>
          <p>{{$t("PayAgreement.pange12")}}</p>
          <h4>{{$t("PayAgreement.pange13")}}</h4>
          <p>{{$t("PayAgreement.pange14")}}</p>
          <p>{{$t("PayAgreement.pange15")}}</p>
          <p>{{$t("PayAgreement.pange16")}}</p>
          <h4>{{$t("PayAgreement.pange17")}}</h4>
          <p>{{$t("PayAgreement.pange18")}}</p>
          <p>{{$t("PayAgreement.pange19")}}</p>
          <p>{{$t("PayAgreement.pange20")}}</p>
          <p>{{$t("PayAgreement.pange21")}}</p>
          <p>{{$t("PayAgreement.pange22")}}</p>
          <p>{{$t("PayAgreement.pange23")}}</p>
          <p>{{$t("PayAgreement.pange24")}}</p>
          <p>{{$t("PayAgreement.pange25")}}</p>
          <p>{{$t("PayAgreement.pange26")}}</p>
          <p>{{$t("PayAgreement.pange27")}}</p>
          <p>{{$t("PayAgreement.pange28")}}</p>
          <p>{{$t("PayAgreement.pange29")}}</p>
          <p>{{$t("PayAgreement.pange30")}}</p>
          <p>{{$t("PayAgreement.pange31")}}</p>
          <p>{{$t("PayAgreement.pange32")}}</p>
          <p>{{$t("PayAgreement.pange33")}}</p>
          <h4>{{$t("PayAgreement.pange34")}}</h4>
          <p>{{$t("PayAgreement.pange35")}}</p>
          <p>{{$t("PayAgreement.pange36")}}</p>
          <p>{{$t("PayAgreement.pange37")}}</p>
          <p>{{$t("PayAgreement.pange38")}}</p>
          <h4>{{$t("PayAgreement.pange39")}}</h4>
          <p>{{$t("PayAgreement.pange40")}}</p>
          <p>{{$t("PayAgreement.pange41")}}</p>
          <p>{{$t("PayAgreement.pange42")}}</p>
          <p>{{$t("PayAgreement.pange43")}}：（ <a href="mailto:xiaoyi@caiyunapp.com" style="color: #5ebb8d;">xiaoyi@caiyunapp.com</a>）</p>
          <div style="text-align: right">{{$t("PayAgreement.pange44")}}</div>
          <div style="text-align: right">{{$t("PayAgreement.pange45")}}</div>
        </div>
      </el-dialog>
    </div>
    <AlertComponent ref="payOver" 
                    @getCloseType="getCloseType"></AlertComponent>
  </div>
</template>
<style scoped>
  @import "../css/list-item.scss";
  .vip-model{
    padding-top:15px;
    padding-left:20px;
    padding-right: 20px;
  }
  .vip-icon{
    margin: 0 auto 24px;
    font-size: 18px;
    color: #666666;
    width:80px;
    text-align: center;
    position: relative;
    color: #666;
  }
  .vip-icon:after{
    left:-10px;
  }
  .vip-icon:before{
    right:-10px;
  }
  .vip-icon:after,.vip-icon:before{
    position: absolute;
    display: block;
    content: '';
    top:50%;
    height:1px;
    width:10px;
    background: #666;
    margin-top: -0.5px;
  }
  .vip-info{
    padding:0 20px;
    margin-bottom: 46px;
  }
  .vip-info > div{
    width: 25%;
    font-size: 16px;
    color: #666666;
    text-align: center;
    float: left;
  }
  .vip-info > div>img{
    width:50px;
    height:50px;
    margin-right: 20px;
    vertical-align: middle;
  }
  .vip-title{
    font-size: 18px;
    color: #666666;
    height:22px;
    line-height:22px;
  }
  .vip-time{
    font-size: 14px;
    color: #999999;
  }
  .vip-title >i{
    width:2px;
    height:22px;
    background-color: #5EBB8D;
    display: inline-block;
    margin-right: 13px;
    vertical-align: middle;
  }
  .vip-full-value{
    padding-top:14px;
  }
  .vip-full-item{
    width:132px;
    /*height:75px;*/
    border:1px solid #ccc;
    border-radius: 4px;
    text-align: center;
    padding-top:20px;
    padding-bottom:28px;
    float: left;
    margin-right: 20px;
    cursor: pointer;
  }
  .vip-full-item.active{
    background: rgba(132, 238, 189, 0.2);
    border-color: #5EBB8D;
  }
  .vip-full-item .vip-full-money{
    color: #5EBB8D;
    padding: 0;
    margin: 0;
    font-weight:bold;
  }
  .vip-full-item .vip-full-money>span:first-child{
    font-size: 18px;
  }
  .vip-full-item .vip-full-money>span:last-child{
    font-size: 30px;
    font-family: PingFangSC-Regular;
  }
  .vip-full-item .vip-full-time{
    font-size: 16px;
    color: #666666;
    margin: 0;
    margin-top: 17px;
  }
  .vip-caiyunpoints{
    width:100%;
    border:1px solid #ccc;
    padding:16px 42px 16px 20px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    margin-bottom:15px ;
    color: #666666;
    border-radius: 4px;
    cursor: pointer;
  }
  .vip-caiyunpoints.active{
    border-color: #5EBB8D;
  }
  .vip-agreement{
    font-size: 16px;
    color: #999999;
    margin-top: 15px;
    cursor: pointer;
    text-align: center;
    margin-bottom: 30px;
  }
  .vip-agreement:hover{
    color: #5EBB8D;
  }
  >>>.vip-pay-full .el-dialog__body{
    height: 120px;
    margin-bottom: 20px;
    padding-left: 30px;
    padding-right: 30px;
  }
  >>>.vip-pay-full .el-dialog__header{
    text-align: left;
    padding-top: 24px;
    padding-left: 30px;
  }
  >>.need-pay{
    float: right;
    line-height: 120px;
    font-size: 18px;
    color: #666666;
  }
  >>>.need-pay>span{
    font-size: 30px;
    color: #FC1833;
  }
  >>>.vip-pay-full .el-button--primary{
    border-radius: 0;
    width: 150px;
    line-height: 17px;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    font-size: 24px;
    height: 41px;
  }
  >>>.vip-pay-full .el-dialog__footer{
    padding-bottom: 40px;
  }
  >>> .vip-pay-full .vip-full-item{
    cursor: pointer;
    width: 160px;
    padding-top: 29px;
    padding-bottom: 36px;
  }
  >>>.vip-pay-points .el-dialog__body{
    font-size: 24px;
    color: #666666;
    text-align: center;
    margin-bottom: 70px;
    margin-top: 20px;
  }
  >>>.vip-pay-points .el-dialog__footer{
    padding-bottom:65px;
  }
  >>>.vip-pay-points  .el-button[type='button']{
    width:132px;
    height:50px;
    border-radius: 2px;
    font-size: 20px;
  }
  >>>.vip-full-points{
    color: #fea310;
  }
  .vip-full-points>img{
    vertical-align: bottom;
    margin-right: 5px;
  }
  .vip-pay-points .el-dialog ,.vip-pay-full .el-dialog{
    width :600px;
  }
  >>>.el-dialog{
    width: 700px;
  }
  @media (max-width:1200px){
    .vip-info > div > img{
      margin: 0 auto 10px;
      float: initial;
      display: block;
    }
    .vip-info > div>span{
      display: block;
      text-align: center;
      float: initial;
    } 
  }
  @media (max-width:650px){
    .vip-icon{
      margin-top:20px;
      font-size: 14px;
    }
    >>>.el-dialog{
        width :90%;
    }
    .vip-info{
      display: flex;
      flex-wrap: nowrap;
      width: 100%;
    }
    .vip-info > div{
      /* width :50%; */
      font-size: 12px;
      float: initial;
      flex: 1;
    }
    .vip-info > div > img{
      margin: 0 auto 10px;
      float: initial;
      display: block;
    }
    .vip-info > div>span{
      display: block;
      text-align: center;
      float: initial;
    } 
    .vip-title{
      font-size: 14px;
    }
    .vip-title >i{
      height: 12px;
      margin-right: 4px;
      margin-top: -3px;
    }
    .vip-full-item {
      width: 100px;
      height: 60px;
    }
    .vip-full-item .vip-full-money>span:last-child {
       font-size: 26px;
    }
    .vip-full-item .vip-full-time{
      font-size: 14px;
      margin-top: 10px;
    }
    .vip-agreement{
      font-size:12px;
    }
  }
  
</style>
<script>
import AlertComponent  from '../components/alertComponent.vue';
import { getDocRecord ,rechargeVIP,getVipList,USER_INFO,upUserData ,isPayDone} from '@/api/user'
import { formatTime ,whatLang} from '@/utils/index'
import config from '../config/config'
import jump from 'jump.js'
import { Message } from 'element-ui';
import jsonp from 'jsonp';
let  payState = [];

export default {
  components:{AlertComponent},
  data() {
    return {
        dialogVisible:false,
        centerDialogVisible:false,
        userAgreement:false,
        pay:{},
        vipFull:[],
        vipPoints:[],
        user:{},
        isPayState:this.$t('vip.PayOk'),
        isPayIndex:0,
        isChinese: whatLang() !='zh',
        out_trade_no:'',
    }
  },
  created() {
    this.getVip();
    this.user = USER_INFO({});
    payState = [this.$t('vip.PayOk') , this.$t('vip.PayOver')];
  },
  methods: {
    payChoose:function(o,index){
      this.vipFull.map(v=>v.active=false);
      this.vipFull[index].active=true;
        this.pay={
          name :o.name,
          price:o.price,
          product_id:o.id
        }
        this.dialogVisible = true;
    },
    payPoint:function (o,index) {
      this.isPayIndex = 0;
      this.vipPoints.map(v=>v.active=false);
      this.vipPoints[index].active = true;
      this.pay={
        name :o.name,
        price:o.price,
        product_id:o.id
      }
      this.centerDialogVisible = true;
    },
    payVip:function () {
        if(this.isPayIndex ===0){
          window.open("about:blank","alipay");
          rechargeVIP(this.pay.product_id).then(res=>{
            if(res.rc == 0 && res.alipay.notify_url){
              this.isPayIndex = 1;
               window.open(null,'alipay').location.href = res.alipay.notify_url;
              this.isPayState = payState[this.isPayIndex];
              this.$refs.payOver.show({});
              const url = decodeURI(res.alipay.notify_url);
              this.out_trade_no = url.match(/&out_trade_no=([a-zA-Z0-9]+)\&/)[1];
            }else{
              Message({
                type:'error',
                message:this.$t('vip.PayError'),
              })
              this.init();
            }
          })
        }else{
          this.init();
        }
    },
    payVipPoint:function () {
      rechargeVIP(this.pay.product_id).then(res=>{
        if(res.rc == 0 && res.is_xy_vip){
          Message({
            type:'success',
            message:this.$t('vip.PayPointOk')
          })
        }else{
          Message({
            type:'error',
            message:this.$t('vip.PayPointErr')
          })
        }
        this.init();
      }).catch(err=>{
        Message({
            type:'error',
            message:this.$t('vip.PayPointErr')
        })
      })
    },
    getVip:function () {
      getVipList().then(res=>{
          if(res.rc == 0 ) {
              this.vipFull = res.pay || [];
              this.vipFull.map(v => {
                const name = v.name ;
                if(name == '30天'){
                    v.name = this.$t('vip.vipList.pay[0]');
                }else if(name == '90天'){
                    v.name = this.$t('vip.vipList.pay[1]');
                }else if(name == '180天'){
                    v.name =this.$t('vip.vipList.pay[2]');
                }else if(name == '365天'){
                  v.name = this.$t('vip.vipList.pay[3]');
                }
                v.active = false
              });
              this.vipPoints = res.point || [];
              this.vipPoints.map(v => {
                const name = v.name ;
                if(name == '7天'){
                    v.name = this.$t('vip.vipList.point[1]');
                }else if(name == '1天'){
                     v.name = this.$t('vip.vipList.point[0]');
                }
                v.active = false
              });
          }
      })
    },
    init:function () {
      this.dialogVisible=false;
      this.centerDialogVisible=false;
      this.userAgreement=false;
      this.pay={};
      this.isPayIndex=0;
      this.isPayState=payState[this.isPayIndex];
      this.vipPoints.map(v=>v.active=false);
      this.vipFull.map(v=>v.active=false);
      upUserData();
    },
    closeDialog:function(type){
        if(type===1){
            this.vipFull.map(v=>v.active=false);
        }else if(type ===2){
            this.vipPoints.map(v=>v.active=false);
        }
    },
    getCloseType:function(obj){
      if(obj.type == 1){
        jsonp('https://ad.caiyunapp.com/pay/'+this.out_trade_no+'/check', null, (err, data) => {
          if (err) {
             Message({
                type:'error',
                message:this.$t('vip.topUpError')
              });
          } else {
            if(data.stauts == 'ok' && data.rc == 3){
              Message({
                type:'success',
                message:this.$t('vip.topUpSuccess')
              });
            }else{
              Message({
                type:'error',
                message:this.$t('vip.topUpError')
              });
            }
          }
        });
        // isPayDone(this.out_trade_no).then(res=>{
        //   console.log(res);
        //   if(res.stauts == 'ok' && res.rc == 3){
        //     Message({
        //       type:'success',
        //       message:this.$t('vip.topUpSuccess')
        //     });
        //   }else{
        //     Message({
        //       type:'error',
        //       message:this.$t('vip.topUpError')
        //     });
        //   }
        // }).catch(err=>{
        //   Message({
        //       type:'error',
        //       message:this.$t('vip.topUpError')
        //   });
        // })
        this.init();
      }else{
         Message({
            type:'error',
            message:this.$t('vip.topUpError')
        })
      }
      this.$refs.payOver.hide();
      this.dialogVisible = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/vip.vue